var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "box"
    },
    [
      _c("p", { staticClass: "login_title_sm" }, [
        _vm._v(_vm._s(_vm.$t("m.change_mobile")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login_info" }, [
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.old_mobile")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c(
              "div",
              {
                staticClass: "seledArea",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.showOldShowCountryFun.apply(null, arguments)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "flag_icon",
                  attrs: { src: _vm.selCountryOld.logo }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "fc-pad-lr-min" }, [
                  _vm._v("+" + _vm._s(_vm.selCountryOld.countryNum))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "select_icon",
                  attrs: {
                    src:
                      _vm.oldShowCountry && _vm.$store.state.isShowSelArea
                        ? require("../../assets/img/icon_up.png")
                        : require("../../assets/img/icon_down.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.oldMobile,
                  expression: "oldMobile",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                placeholder: _vm.$t("m.user_enter_bind_phone"),
                minlength: "6"
              },
              domProps: { value: _vm.oldMobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.oldMobile = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.oldShowCountry && _vm.$store.state.isShowSelArea
              ? _c(
                  "div",
                  { staticClass: "selarea_box" },
                  [
                    _c("sel-area", {
                      on: { countryOption: _vm.countryOptionOldFun }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.vericode")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.oldCode,
                  expression: "oldCode",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input smscode_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                placeholder: _vm.$t("m.input_vericode"),
                maxlength: "6"
              },
              domProps: { value: _vm.oldCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.oldCode = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "getcode" },
              [
                _c("send-code", {
                  attrs: {
                    areaCode: _vm.selCountryOld.countryNum,
                    mobile: _vm.oldMobile,
                    scene: 1
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.new_mobile")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c(
              "div",
              {
                staticClass: "seledArea",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.showNewShowCountryFun.apply(null, arguments)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "flag_icon",
                  attrs: { src: _vm.selCountryNew.logo }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "fc-pad-lr-min" }, [
                  _vm._v("+" + _vm._s(_vm.selCountryNew.countryNum))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "select_icon",
                  attrs: {
                    src:
                      _vm.newShowCountry && _vm.$store.state.isShowSelArea
                        ? require("../../assets/img/icon_up.png")
                        : require("../../assets/img/icon_down.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.newMobile,
                  expression: "newMobile",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                placeholder: _vm.$t("m.user_enter_bind_phone"),
                minlength: "6"
              },
              domProps: { value: _vm.newMobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newMobile = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.newShowCountry && _vm.$store.state.isShowSelArea
              ? _c(
                  "div",
                  { staticClass: "selarea_box" },
                  [
                    _c("sel-area", {
                      on: { countryOption: _vm.countryOptionNewFun }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form_item" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("m.vericode")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form_inputbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.newCode,
                  expression: "newCode",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "login_input smscode_input",
              attrs: {
                type: "text",
                oninput: "value=value.replace(/\\D/g,'')",
                placeholder: _vm.$t("m.input_vericode"),
                maxlength: "6"
              },
              domProps: { value: _vm.newCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newCode = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "getcode" },
              [
                _c("send-code", {
                  attrs: {
                    areaCode: _vm.selCountryNew.countryNum,
                    mobile: _vm.newMobile,
                    scene: 1
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fc-flex-center" }, [
          _c("div", { staticClass: "login_btn", on: { click: _vm.goLogin } }, [
            _vm._v(_vm._s(_vm.$t("m.submit")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "fc-text-center fc-color-gray-light fc-mar-t-min fc-pointer changetxt",
            on: { click: _vm.changephone }
          },
          [_vm._v(_vm._s(_vm.$t("m.return")))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76846238", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76846238","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/changephone.vue
// module id = null
// module chunks = 